module.exports = __webpack_public_path__ + "img/medMission_041022_G.e0ea69ed.jpg";